import { createSelector } from 'reselect';
import { rootSelector } from '../selectors';

/**
 * Returns orgs contacts
 */
export const getOrgContacts = createSelector(
  rootSelector,
  settings => settings.contacts.org.data?.contacts || [],
);

/**
 * Returns umbrella contacts
 */
export const getUmbrellaContacts = createSelector(
  rootSelector,
  settings => settings.contacts.umbrella.data?.contacts || [],
);
